module.exports = __webpack_public_path__ + "img/icon_robot.4c0b4ab0.png";